module.exports = __webpack_public_path__ + "img/1562873387.ab0e72c0.jpg";